import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

interface IStatCard {
  title: string;
  value?: string;
  icon?: React.ReactNode;
}

export const StatCard: React.FC<IStatCard> = ({ title, value, icon }) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 2.5, lg: 3 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: { xs: 'flex-start', lg: 'center' },
        justifyContent: 'center',
        textAlign: { xs: 'left', lg: 'center' },
        gap: { xs: 1.5, lg: 2 },
        borderRadius: 3,
        border: 1,
        borderColor: 'divider',
        width: '100%',
        bgcolor: 'background.paper',
      }}
    >
      {value && (
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            fontSize: { xs: '2rem', lg: '3rem' },
          }}
        >
          {value}
        </Typography>
      )}
      {icon && (
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 1,
            borderColor: 'primary.main',
            color: 'primary.main',
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'primary.main' }}>
        {title}
      </Typography>
    </Paper>
  );
};

export default StatCard;
